import React from 'react';
import RetryButton from '~/components/views/retry/RetryButton/RetryButton';
import './YoutubePlaylistError.pcss';

interface YoutubePlaylistErrorProps {
  callback: () => void;
}

const YoutubePlaylistError: React.FC<YoutubePlaylistErrorProps> = ({
  callback,
}) => {
  return (
    <div className="YoutubePlaylistError">
      <RetryButton
        errorMessage="web.error.internal_error"
        callback={callback}
      />
    </div>
  );
};

export default YoutubePlaylistError;
